module.exports = __webpack_public_path__ + "static/media/bg_harwat.2b09c26c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_harwat.svg
// module id = 534
// module chunks = 14